/*
  hk-stand-details.js  —  Harper Kellee
  Shows an inline "about the stand" panel beneath the Sign Stand option on
  product pages, but only when "Add a stand" is selected. Pulls the stand's
  real photos and description live from the standalone stand listing.
  "See full stand details" opens an in-page quick view (no navigation away).

  Safe to load on every product page: it does nothing unless the page has a
  "Sign Stand" option with an "Add a stand" choice.

  To tweak copy: edit HEADING, DESC, SPECS, or SHIPS below.
*/
(function () {
  'use strict';
  if (window.__hkStandDetails) return;
  window.__hkStandDetails = true;

  var STAND_HANDLE = 'wedding-sign-stand-freestanding-wood-display-stand-for-welcome-arch-signs';
  var STAND_URL = '/products/' + STAND_HANDLE;

  var HEADING = 'Your sign, standing tall';
  var DESC = 'A freestanding wood stand that holds your sign upright and steady wherever your guests gather. Raw and paint-ready, so leave it natural or match it to your colors.';
  var SHIPS = 'Ships in 3 to 5 days';
  var LINK_TEXT = 'See full stand details';

  var SPECS = [
    { icon: '<path d="M12 20V4M12 4l-4 4M12 4l4 4"/>', text: 'Stands 32 inches tall' },
    { icon: '<path d="M4 9l8-4 8 4-8 4z"/><path d="M4 14l8 4 8-4"/>', text: 'Holds signs up to 6 mm thick' },
    { icon: '<circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/>', text: 'Easy to assemble' },
    { icon: '<path d="M12 3c3 4 6 7 6 11a6 6 0 0 1-12 0c0-4 3-7 6-11z"/>', text: 'Ready to paint' }
  ];

  var FALLBACK_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0997/1807/0566/files/Shot3_e5ac5829-c284-4e22-b278-413cf323cd9f.png',
    'https://cdn.shopify.com/s/files/1/0997/1807/0566/files/Shot1_4bda1db2-16a8-437d-8fe4-f1b1f850bf26.png',
    'https://cdn.shopify.com/s/files/1/0997/1807/0566/files/Closeup_d3b557fe-fd5e-411d-bc30-a4940733ced3.png',
    'https://cdn.shopify.com/s/files/1/0997/1807/0566/files/Shot2_10723a65-4de5-4bc8-b95c-958aa3cb0def.png',
    'https://cdn.shopify.com/s/files/1/0997/1807/0566/files/Shot4_1e100f58-43f7-4b8b-8821-c0b06d3d4835.png'
  ];

  var CSS = [
    '#hksd-panel{border:1px solid rgba(23,20,12,.14);background:#f6efe3;border-radius:12px;padding:16px;margin-top:14px;margin-bottom:4px;color:#17140c}',
    '.hksd-top{display:flex;gap:18px;flex-wrap:wrap}',
    '.hksd-hero{flex:0 0 184px;width:184px;aspect-ratio:4 / 5;max-height:300px;background:#fff;border:1px solid rgba(23,20,12,.14);border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center;cursor:zoom-in}',
    '.hksd-hero img{width:100%;height:100%;object-fit:contain}',
    '.hksd-thumbs{display:flex;gap:8px;margin-top:16px;flex-wrap:wrap}',
    '.hksd-th{width:50px;height:50px;border:1px solid rgba(23,20,12,.14);border-radius:8px;overflow:hidden;background:#fff;padding:0;cursor:pointer}',
    '.hksd-th img{width:100%;height:100%;object-fit:cover;display:block}',
    '.hksd-th.is-on{border:2px solid #44503d}',
    '.hksd-body{flex:1;min-width:188px}',
    '.hksd-h{font-size:20px;font-weight:500;line-height:1.2;margin:0 0 8px;color:#17140c}',
    '.hksd-desc{font-size:13px;line-height:1.55;color:rgba(23,20,12,.72);margin:0 0 13px}',
    '.hksd-chips{display:grid;grid-template-columns:repeat(auto-fit,minmax(148px,1fr));gap:7px}',
    '.hksd-chip{display:flex;align-items:center;gap:7px;width:100%;box-sizing:border-box;background:#fff;border:1px solid rgba(23,20,12,.14);border-radius:9px;padding:8px 11px;font-size:12px;color:#17140c;line-height:1.25}',
    '.hksd-chip svg{width:14px;height:14px;stroke:#44503d;fill:none;stroke-width:1.6;flex:0 0 auto}',
    '.hksd-linkrow{display:flex;justify-content:flex-end;margin-top:12px}',
    '.hksd-link{font-size:13px;color:#44503d;font-weight:500;background:none;border:none;font-family:inherit;display:inline-flex;align-items:center;gap:6px;cursor:pointer;padding:0}',
    '.hksd-link:hover{text-decoration:underline}',
    '.hksd-link svg{width:15px;height:15px;stroke:currentColor;fill:none;stroke-width:1.7}',
    '@media(max-width:360px){.hksd-chips{grid-template-columns:1fr}}',
    '.hksd-lb{position:fixed;inset:0;background:rgba(23,20,12,.88);display:none;align-items:center;justify-content:center;z-index:99999}',
    '.hksd-lb.is-open{display:flex}',
    '.hksd-lb img{max-width:88vw;max-height:84vh;object-fit:contain;border-radius:6px}',
    '.hksd-lb button{position:absolute;background:none;border:none;color:#fff;cursor:pointer;font-family:inherit}',
    '.hksd-x{top:16px;right:22px;font-size:32px;line-height:1}',
    '.hksd-nav{top:50%;transform:translateY(-50%);font-size:40px;padding:0 16px;opacity:.85}',
    '.hksd-prev{left:4px}.hksd-next{right:4px}',
    '.hksd-modal{position:fixed;inset:0;background:rgba(23,20,12,.55);display:none;align-items:center;justify-content:center;z-index:9990;padding:20px}',
    '.hksd-modal.is-open{display:flex}',
    '.hksd-mcard{background:#faf7f0;color:#17140c;border-radius:14px;max-width:760px;width:100%;max-height:88vh;overflow:auto;padding:24px;position:relative;box-shadow:0 18px 50px rgba(23,20,12,.22)}',
    '.hksd-mx{position:absolute;top:13px;right:15px;background:none;border:none;font-size:27px;line-height:1;color:#17140c;cursor:pointer;opacity:.55}',
    '.hksd-mx:hover{opacity:1}',
    '.hksd-mtitle{font-size:20px;font-weight:500;margin:0 0 16px;padding-right:28px}',
    '.hksd-mgrid{display:flex;gap:22px;flex-wrap:wrap;align-items:flex-start}',
    '.hksd-mgal{width:300px;flex:0 0 300px}',
    '.hksd-mmain{width:300px;aspect-ratio:4 / 5;max-height:420px;background:#fff;border:1px solid rgba(23,20,12,.12);border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center;cursor:zoom-in}',
    '.hksd-mmain img{width:100%;height:100%;object-fit:contain}',
    '.hksd-mthumbs{display:flex;gap:7px;margin-top:8px;flex-wrap:wrap}',
    '.hksd-minfo{flex:1;min-width:240px}',
    '.hksd-rich h4{font-size:12px;text-transform:uppercase;letter-spacing:.06em;margin:15px 0 6px;color:#17140c;font-weight:600}',
    '.hksd-rich h4:first-child{margin-top:0}',
    '.hksd-rich p{font-size:13px;line-height:1.6;color:#4a4438;margin:0 0 9px}',
    '.hksd-rich ul{margin:0 0 9px;padding-left:17px}',
    '.hksd-rich li{font-size:12.5px;line-height:1.5;color:#4a4438;margin:3px 0}',
    '.hksd-rich strong{font-weight:500;color:#17140c}',
    '@media(max-width:620px){.hksd-mgal,.hksd-mmain{width:100%;flex-basis:100%}.hksd-mmain{max-height:340px}}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('hksd-styles')) return;
    var s = document.createElement('style');
    s.id = 'hksd-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function chipHtml(spec) {
    return '<span class="hksd-chip"><svg viewBox="0 0 24 24">' + spec.icon + '</svg>' + spec.text + '</span>';
  }

  function findStandField() {
    var btns = document.querySelectorAll('.hkwd-optbtn');
    for (var i = 0; i < btns.length; i++) {
      if (/add a stand/i.test(btns[i].textContent)) {
        return btns[i].closest('.hkwd-field');
      }
    }
    return null;
  }

  function selectedIsAdd(field) {
    var on = field.querySelector('.hkwd-optbtn.is-on');
    if (!on) return false;
    return !/no stand/i.test(on.textContent);
  }

  var standCache = null, fetchTried = false;
  function getStand(cb) {
    if (standCache) { cb(standCache); return; }
    if (fetchTried) { cb({ images: FALLBACK_IMAGES, desc: '' }); return; }
    fetchTried = true;
    fetch(STAND_URL + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.images || []).map(function (u) { return u.indexOf('//') === 0 ? ('https:' + u) : u; });
        standCache = { images: imgs.length ? imgs.slice(0, 8) : FALLBACK_IMAGES, desc: p.description || '' };
        cb(standCache);
      })
      .catch(function () { standCache = { images: FALLBACK_IMAGES, desc: '' }; cb(standCache); });
  }

  function buildThumbStrip(container, images, onSelect) {
    container.innerHTML = '';
    images.forEach(function (src, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hksd-th' + (i === 0 ? ' is-on' : '');
      b.innerHTML = '<img src="' + src + '" alt="Stand photo ' + (i + 1) + '">';
      b.onclick = function () {
        onSelect(i);
        var kids = container.children;
        for (var k = 0; k < kids.length; k++) kids[k].classList.toggle('is-on', k === i);
      };
      container.appendChild(b);
    });
  }

  var lb, lbImg, lbList = [], lbIdx = 0;
  function buildLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'hksd-lb';
    lb.innerHTML = '<button class="hksd-x" aria-label="Close">&times;</button>' +
      '<button class="hksd-nav hksd-prev" aria-label="Previous">&#8249;</button>' +
      '<img alt="Stand photo enlarged">' +
      '<button class="hksd-nav hksd-next" aria-label="Next">&#8250;</button>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img');
    function close() { lb.classList.remove('is-open'); }
    function show(n) { lbIdx = (n + lbList.length) % lbList.length; lbImg.src = lbList[lbIdx]; }
    lb.querySelector('.hksd-x').onclick = close;
    lb.querySelector('.hksd-prev').onclick = function (e) { e.stopPropagation(); show(lbIdx - 1); };
    lb.querySelector('.hksd-next').onclick = function (e) { e.stopPropagation(); show(lbIdx + 1); };
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(lbIdx - 1);
      else if (e.key === 'ArrowRight') show(lbIdx + 1);
    });
    lb._show = show;
  }
  function openLightbox(list, idx) {
    buildLightbox();
    lbList = list;
    lb._show(idx);
    lb.classList.add('is-open');
  }

  var modal;
  function openModal(stand) {
    injectStyles();
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'hksd-modal';
      modal.innerHTML =
        '<div class="hksd-mcard" role="dialog" aria-modal="true" aria-label="Stand details">' +
          '<button class="hksd-mx" aria-label="Close">&times;</button>' +
          '<h3 class="hksd-mtitle">' + HEADING + '</h3>' +
          '<div class="hksd-mgrid">' +
            '<div class="hksd-mgal">' +
              '<div class="hksd-mmain"><img alt="Wedding sign stand"></div>' +
              '<div class="hksd-mthumbs"></div>' +
            '</div>' +
            '<div class="hksd-minfo"><div class="hksd-rich"></div></div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);

      var mmainBox = modal.querySelector('.hksd-mmain');
      var mainImg = mmainBox.querySelector('img');
      var mthumbs = modal.querySelector('.hksd-mthumbs');
      var rich = modal.querySelector('.hksd-rich');
      var mcur = 0;
      function applyMainRatio() {
        if (mainImg.naturalWidth && mainImg.naturalHeight) {
          mmainBox.style.aspectRatio = mainImg.naturalWidth + ' / ' + mainImg.naturalHeight;
        }
      }
      mainImg.onload = applyMainRatio;
      function showMain(src) { mainImg.src = src; if (mainImg.complete) applyMainRatio(); }
      modal._fill = function (st) {
        var imgs = st.images || FALLBACK_IMAGES;
        mcur = 0;
        showMain(imgs[0]);
        buildThumbStrip(mthumbs, imgs, function (i) { mcur = i; showMain(imgs[i]); });
        mmainBox.onclick = function () { openLightbox(imgs, mcur); };
        if (st.desc && st.desc.replace(/<[^>]*>/g, '').trim()) {
          rich.innerHTML = st.desc;
        } else {
          rich.innerHTML = '<p>' + DESC + '</p><h4>Dimensions</h4><ul>' +
            SPECS.map(function (s) { return '<li>' + s.text + '</li>'; }).join('') + '</ul>';
        }
      };
      function closeM() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
      modal.querySelector('.hksd-mx').onclick = closeM;
      modal.addEventListener('click', function (e) { if (e.target === modal) closeM(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open') && (!lb || !lb.classList.contains('is-open'))) closeM();
      });
    }
    modal._fill(stand);
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function buildPanel(stand) {
    var images = stand.images;
    var panel = document.createElement('div');
    panel.id = 'hksd-panel';
    panel.style.display = 'none';
    var chips = SPECS.map(chipHtml).join('');
    panel.innerHTML =
      '<div class="hksd-top">' +
        '<div class="hksd-hero"><img alt="Wedding sign stand"></div>' +
        '<div class="hksd-body">' +
          '<p class="hksd-h">' + HEADING + '</p>' +
          '<p class="hksd-desc">' + DESC + '</p>' +
          '<div class="hksd-chips">' + chips + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="hksd-thumbs"></div>' +
      '<div class="hksd-linkrow">' +
        '<button type="button" class="hksd-link">' + LINK_TEXT +
          '<svg viewBox="0 0 24 24"><path d="M8 4H5a1 1 0 0 0-1 1v3M16 4h3a1 1 0 0 1 1 1v3M16 20h3a1 1 0 0 0 1-1v-3M8 20H5a1 1 0 0 1-1-1v-3"/></svg></button>' +
      '</div>';

    var heroBox = panel.querySelector('.hksd-hero');
    var heroImg = heroBox.querySelector('img');
    var thumbs = panel.querySelector('.hksd-thumbs');
    var cur = 0;
    function applyHeroRatio() {
      if (heroImg.naturalWidth && heroImg.naturalHeight) {
        heroBox.style.aspectRatio = heroImg.naturalWidth + ' / ' + heroImg.naturalHeight;
      }
    }
    heroImg.onload = applyHeroRatio;
    function showHero(src) { heroImg.src = src; if (heroImg.complete) applyHeroRatio(); }
    showHero(images[0]);
    buildThumbStrip(thumbs, images, function (i) { cur = i; showHero(images[i]); });
    heroBox.onclick = function () { openLightbox(images, cur); };
    panel.querySelector('.hksd-link').onclick = function () { openModal(stand); };
    return panel;
  }

  function sync() {
    var field = findStandField();
    var panel = document.getElementById('hksd-panel');
    if (!field || !panel) return;
    panel.style.display = selectedIsAdd(field) ? 'block' : 'none';
  }

  var mounting = false;
  function mount() {
    if (document.getElementById('hksd-panel')) { sync(); return; }
    var field = findStandField();
    if (!field || mounting) return;
    mounting = true;
    injectStyles();
    getStand(function (stand) {
      mounting = false;
      if (document.getElementById('hksd-panel')) { sync(); return; }
      var liveField = findStandField();
      if (!liveField) return;
      var panel = buildPanel(stand);
      liveField.insertAdjacentElement('afterend', panel);
      var h1 = document.querySelector('.main-content h1') || document.querySelector('h1');
      if (h1) {
        var f = getComputedStyle(h1).fontFamily;
        if (f) {
          panel.querySelector('.hksd-h').style.fontFamily = f;
        }
      }
      liveField.addEventListener('click', function (e) {
        if (e.target.closest('.hkwd-optbtn')) setTimeout(sync, 0);
      });
      sync();
      if (obs) obs.disconnect();
    });
  }

  var raf = 0;
  var obs = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; mount(); });
  });

  function start() {
    mount();
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', mount);
})();